import { debounce } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Returns a ref and px value of the distance from the top of the viewport to the top of the element
 * Automatically updates when the window is resized and is debounced
 *
 */
function useOffsetTop(delay = 250) {
  const [offsetTop, setOffsetTop] = useState(0);
  const ref = useRef<HTMLElement | null>(null);

  const onChange = useCallback((el: HTMLElement) => {
    if (!el) return;
    setOffsetTop(el.offsetTop);
  }, []);

  useEffect(() => {
    const onRefChange = () => {
      onChange(ref.current!);
    };

    const handleResize = debounce(onRefChange, delay);

    window.addEventListener('resize', handleResize);

    onRefChange();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [delay, onChange]);

  return [ref, offsetTop, onChange] as const;
}

export default useOffsetTop;
